import { useEffect } from "react";

export function usePreloadImages(records, imageField = "ImageUrl") {
  useEffect(() => {
    if (!records || !records.length) return;

    records.forEach((record) => {
      const url = record.fields?.[imageField];
      if (url) {
        const img = new Image();
        img.src = url;
      }
    });
  }, [records, imageField]);
}
